import { render } from "./Footer.vue?vue&type=template&id=7c47f6bd&scoped=true&bindings={\"currentYear\":\"data\"}"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=7c47f6bd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c47f6bd"

export default script